
























































































































import {Action, Mutation, State, Getter} from 'vuex-class';
import {Component, Vue} from 'vue-property-decorator';
import {
  FETCH_PROFILE_LIST,
  CREATE_PROFILE_LIST,
  GET_PROFILE_LIST,
  GET_REGISTER_PROFILE_FORM_VISIBILITY,
  UPDATE_REGISTER_PROFILE_FORM_VISIBILITY,
  UPDATE_SELECTED_PROFILE,
  FETCH_FLAG_LIST,
  FETCH_VEHICLE_TYPE_LIST,
  FETCH_COUNTRY_LIST,
  FETCH_PROFILE_FUNCTIONALITIES,
  UPDATE_SELECTED_PROFILE_FUNCTIONALITIES,
  GET_CURRENT_PROFILE_TAB,
  UPDATE_CURRENT_PROFILE_TAB,
  FETCH_PROFILE_FUNCTIONALITIES_REPORT,
} from '@/modules/profile/store';
import {buildDownloadFile} from '@/modules/neovehicle/services/services';
import {getCountry, getCountryName} from '@/utils';

import {IProfile} from '@/modules/profile/models';
import {RootState} from '@/store';
import {IVehicleType, ICountry, IFlag} from '@/models';
import {IFunctionality} from '@/modules/functionality/models';
import {nameof} from 'ts-simple-nameof';
import {profileTabs} from '@/modules/profile/models/Tabs';

@Component
export default class extends Vue {
  public isLoading: boolean = false;
  public generatingFile: boolean = false;
  public showRegisterForm: boolean = false;
  public tabs = profileTabs.tabs;
  public search: string = '';
  public selected: any[] = [];
  public isOnlyActive = true;
  public headersStores: any[] = [
    {text: 'Perfil', value: 'name'},
    {text: 'Bandeira', value: 'flag.flagname'},
    {text: 'Tipo Veículo', value: 'vehicle.vehicletypename'},
    {text: 'País', value: 'country.countryname'},
    {text: 'Status', sortable: false, value: 'isactive'},
  ];

  public pagination: any = {
    sortBy: 'name',
    descending: false,
  };

  @Getter(GET_PROFILE_LIST)
  public profiles: IProfile[];

  @Getter(GET_CURRENT_PROFILE_TAB)
  public currentTab: string;

  @Action(UPDATE_CURRENT_PROFILE_TAB)
  private setProfileCurrentTab: any;

  @Action(FETCH_PROFILE_LIST)
  private getAllProfiles: any;

  @Action(CREATE_PROFILE_LIST)
  private setAllProfiles: any;

  @Action(FETCH_FLAG_LIST)
  private getAllFlags: any;

  @Action(FETCH_VEHICLE_TYPE_LIST)
  private getAllVehicleTypes: any;

  @Action(FETCH_COUNTRY_LIST)
  private getAllCountries: any;

  @Action(UPDATE_SELECTED_PROFILE)
  private setSelectedProfile: any;

  @Action(FETCH_PROFILE_FUNCTIONALITIES)
  private getProfileFunctionalities: any;

  @Action(UPDATE_SELECTED_PROFILE_FUNCTIONALITIES)
  private setProfileFunctionalities: any;

  @Action(FETCH_PROFILE_FUNCTIONALITIES_REPORT)
  private exportProfileFunctionalitiesReport: any;

  public created() {
    this.isLoading = true;
    this.getAllProfiles(this.isOnlyActive)
      .then((ret: any) => {
        const profiles: IProfile[] = ret.data;
        this.setAllProfiles(profiles);
        this.isLoading = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
    this.getAllVehicleTypes();
    this.getAllCountries();
    this.getAllFlags();
  }

  public habilitarCadastro() {
    this.setProfileCurrentTab(profileTabs.tabs.registertab);
  }

  public selectProfile(selectedProfile: IProfile) {
    this.getProfileFunctionalities(selectedProfile.id).then((ret: any) => {
      const profileFunctionalities: IFunctionality[] = ret.data;

      this.setSelectedProfile(selectedProfile);
      this.setProfileFunctionalities(profileFunctionalities);
      this.setProfileCurrentTab(profileTabs.tabs.registertab);
    });
  }

  public exportProfileFunctionalities() {
    const countryName = getCountryName(getCountry());
    const today = new Date();
    const date = [
      today.getFullYear(),
      String(today.getMonth() + 1).padStart(2, '0'),
      String(today.getDate()).padStart(2, '0'),
    ].join('-');

    this.generatingFile = true;
    this.exportProfileFunctionalitiesReport(this.isOnlyActive)
      .then(buildDownloadFile(
        `perfis_funcionalidades_${countryName}_${date}.xlsx`,
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      ))
      .catch((err: any) => console.log(err))
      .finally(() => {
        this.generatingFile = false;
      });
  }

  public setTab(selectedTab: string) {
    this.setProfileCurrentTab(selectedTab);
  }

  public getBadgeColor(icatv: boolean) {
    return icatv ? 'teal' : 'red';
  }

  public onFilter() {
    this.isLoading = true;

    this.getAllProfiles(this.isOnlyActive)
      .then((ret: any) => {
        const profiles: IProfile[] = ret.data;
        this.setAllProfiles(profiles);
        this.isLoading = false;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
